import React, { useState, useEffect } from 'react';

const Testimonials = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
        setIsAnimating(false);
      }, 500);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [data.length]);

  const currentTestimonial = data[currentIndex];

  return (
    <section id="testimonials" className="section-container testimonials-section">
      <div className="content-wrapper">
        <div className="section-header">
          <h2 className="section-title">What People Say</h2>
        </div>

        <div className="testimonials-container">
          <div className={`testimonial-card ${isAnimating ? 'fade-out' : 'fade-in'}`}>
            <div className="quote-icon">❝</div>
            <p className="testimonial-content">{currentTestimonial.content}</p>
            <div className="testimonial-author">
              <div className="author-info">
                <p className="author-name">{currentTestimonial.name}</p>
                <p className="author-title">{currentTestimonial.title}</p>
                <p className="author-company">{currentTestimonial.company}</p>
              </div>
            </div>
          </div>

          {/* Pagination dots */}
          {data.length > 1 && (
            <div className="testimonial-dots">
              {data.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => {
                    setIsAnimating(true);
                    setTimeout(() => {
                      setCurrentIndex(index);
                      setIsAnimating(false);
                    }, 500);
                  }}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;


